export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8529.b276913b.jpg";